
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSettingsDefaultProposal as ObiSettingsDefaultProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-settings-default-proposal.js';
 
 
 

 
 export const ObiSettingsDefaultProposal = createComponent({
   react: React,
   tagName: 'obi-settings-default-proposal',
   elementClass: ObiSettingsDefaultProposalElement,
   events: {
     
   }
  });
 
 